import { request } from '@utils';

const addSubscription = async ({ subscriptionId, body }) => {
  const params = {
    body,
  };

  const results = await request.post(
    `/v1/subscriptions/${subscriptionId}/subscribers`,
    params
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const addTempPredelSubscription = async (payload) => {
  const params = {
    body: payload,
  };

  const results = await request.post(`/v1/subscriptions/predel-temp`, params);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};
export { addSubscription, addTempPredelSubscription };
